import React from 'react';
import { useNavigate } from 'react-router-dom';

const GroupConsultationUpsellModal = ({ isOpen, onClose, onContinueToCheckout }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleBuyLicensingGuide = () => {
    onClose();
    navigate('/checkout?product=licensing-guide');
  };

  const handleSkip = () => {
    onClose();
    onContinueToCheckout();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-fadeIn">
      <div className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border-4 border-yellow-400">
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-400 p-8 text-center relative">
          <button
            onClick={handleSkip}
            className="absolute top-4 right-4 bg-black/20 hover:bg-black/40 text-white rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold transition-all"
            aria-label="Close"
          >
            ×
          </button>
          
          <div className="mb-4">
            <span className="inline-block bg-red-600 text-white px-6 py-2 rounded-full text-sm font-black uppercase animate-pulse">
              ⚡ WAIT! Special Offer ⚡
            </span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-3">
            Before You Register...
          </h2>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Get the Licensing Guide for Only $79!
          </h3>
          <p className="text-gray-800 text-lg font-semibold max-w-2xl mx-auto">
            Start preparing NOW with our comprehensive 50-state licensing guide - perfect to review before the class!
          </p>
        </div>

        {/* Content */}
        <div className="p-8 bg-gray-900">
          <div className="text-center mb-6">
            <p className="text-yellow-400 text-xl font-bold mb-2">💡 Smart Move: Get Prepared First</p>
            <p className="text-gray-300 text-lg">Review your state's requirements before the group consultation</p>
          </div>

          {/* Product Highlight */}
          <div className="bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl p-8 border-4 border-blue-500 mb-8 transform hover:scale-105 transition-all shadow-2xl">
            <div className="text-center mb-6">
              <div className="inline-block bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-black uppercase mb-4">
                📚 Bestseller
              </div>
              <h3 className="text-3xl font-black text-white mb-3">Licensed or Unlicensed Guide</h3>
              <p className="text-blue-200 mb-4 text-lg">Understand exactly what's required in YOUR state</p>
              <div className="bg-blue-600/30 rounded-lg p-4 mb-4">
                <div className="text-5xl font-black text-yellow-400 mb-2">$79</div>
                <p className="text-blue-100 text-sm">Instant Digital Download</p>
              </div>
            </div>

            <ul className="space-y-3 mb-6 text-sm">
              <li className="flex items-start text-white">
                <span className="text-green-400 mr-3 text-xl flex-shrink-0">✓</span>
                <span>All 50 states covered with specific requirements</span>
              </li>
              <li className="flex items-start text-white">
                <span className="text-green-400 mr-3 text-xl flex-shrink-0">✓</span>
                <span>Direct links to state health departments</span>
              </li>
              <li className="flex items-start text-white">
                <span className="text-green-400 mr-3 text-xl flex-shrink-0">✓</span>
                <span>Certificate of Need (CON) states identified</span>
              </li>
              <li className="flex items-start text-white">
                <span className="text-green-400 mr-3 text-xl flex-shrink-0">✓</span>
                <span>Download immediately and start today</span>
              </li>
            </ul>

            <button
              onClick={handleBuyLicensingGuide}
              className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 text-black py-4 rounded-lg font-black hover:from-yellow-500 hover:to-orange-600 transition-all text-xl uppercase tracking-wide shadow-xl"
            >
              Yes! Add Guide for $79 →
            </button>
          </div>

          {/* Skip Option */}
          <div className="text-center">
            <button
              onClick={handleSkip}
              className="text-gray-400 hover:text-white font-semibold text-lg underline"
            >
              No thanks, just register me for the group consultation
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupConsultationUpsellModal;
